import { MenuService } from '@/layout/service/menu.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { PessoaResponseModel } from '@/shared/components/pessoa/pesquisa/pessoa.model';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';

/**
 * Componente principal (layout) para o módulo de Gestão Administrativa.
 * Responsável por renderizar as rotas filhas, gerenciar o menu lateral
 * e definir a identificação do módulo no topbar.
 */
@Component({
    selector: 'app-gestao-admministrativa-content',
    standalone: true,
    imports: [RouterModule],
    template: `
        <!-- No seu componente de layout principal -->
        <main class="w-full">
            <div>
                <router-outlet></router-outlet>
            </div>
        </main>
    `
})
export class GestaoAdministrativaContent implements OnInit {
    private readonly menuService = inject(MenuService);

    /** Caminho base para as rotas do módulo. */
    rootPath = 'gestao-administrativa';

    /** Estrutura do menu de navegação específico para o módulo de Gestão Administrativa. */
    menu = [
        {
            label: 'Home',
            expanded: true,
            items: [
                {
                    label: 'Estatísticas de Médicos',
                    icon: 'pi pi-fw pi-user',
                    expanded: true,
                    items: [
                        { label: 'Mapa de Pendências', icon: 'pi pi-fw pi-list-check', routerLink: [this.rootPath, 'mapa-pendencias'], data: { breadcrumb: 'Mapa de Pendências' } },
                        { label: 'Mapa Controle Cadastro', icon: 'pi pi-fw pi-map', routerLink: [this.rootPath, 'mapa-brasil'], data: { breadcrumb: 'Mapa Controle Cadastro' } },
                        { label: 'Mapa de Calor', icon: 'pi pi-fw pi-chart-scatter', routerLink: [this.rootPath, 'mapa-calor'], data: { breadcrumb: 'Mapa de Calor' } },
                        { label: 'Médicos Ativos por Data', icon: 'pi pi-fw pi-users', routerLink: [this.rootPath, 'medicos-ativos-data'], data: { breadcrumb: 'Médicos Ativos por Data' } },
                        { label: 'Cadastro Geral de Médicos', icon: 'pi pi-fw pi-database', routerLink: [this.rootPath, 'cadastro-geral'], data: { breadcrumb: 'Cadastro Geral de Médicos' } },
                        { label: 'Situação Mensal', icon: 'pi pi-fw pi-calendar', routerLink: [this.rootPath, 'situacao-mensal'], data: { breadcrumb: 'Situação Mensal' } },
                        { label: 'Participação Eleitoral', icon: 'pi pi-fw pi-check-square', routerLink: [this.rootPath, 'participacao-eleitoral'], data: { breadcrumb: 'Participação Eleitoral' } },
                        { label: 'Qualidade e Monitoramento', icon: 'pi pi-fw pi-shield', routerLink: [this.rootPath, 'qualidade-monitoramento'], data: { breadcrumb: 'Qualidade e Monitoramento' } },
                        {
                            label: 'Mapa de Inconsistências de Cadastro',
                            icon: 'pi pi-fw pi-chart-pie',
                            routerLink: [this.rootPath, 'inconsistencias-cadastro'],
                            data: { breadcrumb: 'Mapa de Inconsistências de Cadastro' }
                        },
                        {
                            label: 'Estatísticas de Cadastro',
                            icon: 'pi pi-fw pi-chart-line',
                            expanded: true,
                            data: { breadcrumb: 'Estatísticas de Cadastro' },
                            items: [
                                { label: 'Evolução', icon: 'pi pi-fw pi-chart-line', routerLink: [this.rootPath, 'estatisticas-cadastro', 'evolucao'], data: { breadcrumb: 'Evolução' } },
                                { label: 'Perfil', icon: 'pi pi-fw pi-users', routerLink: [this.rootPath, 'estatisticas-cadastro', 'perfil'], data: { breadcrumb: 'Perfil' } },
                                { label: 'Endereço', icon: 'pi pi-fw pi-map-marker', routerLink: [this.rootPath, 'estatisticas-cadastro', 'endereco'], data: { breadcrumb: 'Endereço' } },
                                { label: 'Formação', icon: 'pi pi-fw pi-graduation-cap', routerLink: [this.rootPath, 'estatisticas-cadastro', 'formacao'], data: { breadcrumb: 'Formação' } },
                                { label: 'Registro', icon: 'pi pi-fw pi-id-card', routerLink: [this.rootPath, 'estatisticas-cadastro', 'registro'], data: { breadcrumb: 'Registro' } },
                                { label: 'Transferência', icon: 'pi pi-fw pi-arrow-right-arrow-left', routerLink: [this.rootPath, 'estatisticas-cadastro', 'transferencia'], data: { breadcrumb: 'Transferência' } },
                                { label: 'Situação', icon: 'pi pi-fw pi-verified', routerLink: [this.rootPath, 'estatisticas-cadastro', 'situacao'], data: { breadcrumb: 'Situação' } },
                                { label: 'Operacional', icon: 'pi pi-fw pi-briefcase', routerLink: [this.rootPath, 'estatisticas-cadastro', 'operacional'], data: { breadcrumb: 'Operacional' } },
                                { label: 'Qualidade', icon: 'pi pi-fw pi-check-circle', routerLink: [this.rootPath, 'estatisticas-cadastro', 'qualidade'], data: { breadcrumb: 'Qualidade' } },
                                { label: 'Especialidade', icon: 'pi pi-fw pi-star', routerLink: [this.rootPath, 'estatisticas-cadastro', 'especialidade'], data: { breadcrumb: 'Especialidade' } }
                            ]
                        }
                    ]
                },
                {
                    label: 'Estatísticas de Prestador',
                    icon: 'pi pi-fw pi-building',
                    expanded: true,
                    items: [
                        { label: 'Prestadores Ativos por Data', icon: 'pi pi-fw pi-building', routerLink: [this.rootPath, 'prestadores-ativos-data'], data: { breadcrumb: 'Prestadores Ativos por Data' } },
                        { label: 'Cadastro Geral de Prestadores', icon: 'pi pi-fw pi-database', routerLink: [this.rootPath, 'cadastro-geral-prestador'], data: { breadcrumb: 'Cadastro Geral de Prestadores' } },
                        { label: 'Câmaras e Comissões Técnicas', icon: 'pi pi-fw pi-sitemap', routerLink: [this.rootPath, 'comissoes-tecnicas'], data: { breadcrumb: 'Câmaras e Comissões Técnicas' } },
                        {
                            label: 'Estatísticas de Cadastro do Prestador',
                            icon: 'pi pi-fw pi-chart-line',
                            expanded: true,
                            data: { breadcrumb: 'Estatísticas de Prestador' },
                            items: [
                                { label: 'Situação', icon: 'pi pi-fw pi-verified', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'situacao'], data: { breadcrumb: 'Situação' } },
                                { label: 'Perfil jurídico', icon: 'pi pi-fw pi-building', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'perfil-juridico'], data: { breadcrumb: 'Perfil jurídico' } },
                                { label: 'Localização', icon: 'pi pi-fw pi-map-marker', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'localizacao'], data: { breadcrumb: 'Localização' } },
                                { label: 'Certificados', icon: 'pi pi-fw pi-file-check', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'certificados'], data: { breadcrumb: 'Certificados' } },
                                { label: 'Diretoria', icon: 'pi pi-fw pi-user-edit', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'diretoria'], data: { breadcrumb: 'Diretoria' } },
                                { label: 'Comissão', icon: 'pi pi-fw pi-users', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'comissao'], data: { breadcrumb: 'Comissão' } },
                                { label: 'Serviços', icon: 'pi pi-fw pi-briefcase', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'servicos'], data: { breadcrumb: 'Serviços' } },
                                { label: 'Operacional', icon: 'pi pi-fw pi-inbox', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'operacional'], data: { breadcrumb: 'Operacional' } },
                                { label: 'Pendências', icon: 'pi pi-fw pi-exclamation-triangle', routerLink: [this.rootPath, 'estatisticas-cadastro-prestador', 'pendencias'], data: { breadcrumb: 'Pendências' } }
                            ]
                        }
                    ]
                }
            ]
        }
    ];

    /**
     * Hook do ciclo de vida. Executado na inicialização do componente.
     * Define o menu específico deste módulo no serviço de menu global.
     */
    ngOnInit(): void {
        this.menuService.setMenu(this.menu);
        // O nome no topbar só muda quando algum módulo o define: sem isto, entrar aqui por link
        // direto ou vindo de outro módulo mantinha o nome do módulo anterior. O texto acompanha
        // o rótulo do lançador da tela inicial.
        this.menuService.setSistema('SICOM | Gestão Administrativa');
    }
}
